<template>
  <section class="programs-section">
    <div class="section__container">
      <!-- Section Title for Small Screens -->
      <h2 class="section__title section__title--mobile">Empowering Initiatives</h2>

      <v-row class="section__row">
        <v-col class="section__col" cols="12" sm="12" md="7" lg="7">
          <keep-alive>
            <v-img
              eager
              cover
              :src="require('@/assets/img/programs-section.webp')"
              :lazy-src="require('@/assets/img/lazy-img.jpg')"
              class="section__img"
            ></v-img>
          </keep-alive>
        </v-col>
        <v-col class="section__col" cols="12" sm="12" md="5" lg="5">
          <div class="programs__wrapper">
            <!-- Section Title for Larger Screens -->
            <h3 class="section__title section__title--desktop">Empowering Initiatives</h3>
            <div class="program__item" v-for="(program, index) in programs" :key="index">
              <div class="program__content">
                <img
                  :src="require('@/assets/img/right-arrow.svg')"
                  alt="Right Arrow"
                  class="program__arrow"
                />
                <div>
                  <p class="program__title">{{ program.title }}</p>
                  <p class="program__description">{{ program.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProgramsSection',
  data() {
    return {
      programs: [
        {
          title: 'Scholarships for Aspiring Talent',
          description: 'Financial support to unlock potential and foster growth.',
        },
        {
          title: 'Internship Opportunities',
          description: 'Hands-on experience to kickstart professional careers.',
        },
        {
          title: 'Mentorship Programs',
          description: 'Guidance from industry experts to navigate career paths.',
        },
        {
          title: 'Entry-Level Career Opportunities',
          description: 'Opening doors to meaningful jobs for emerging professionals.',
        },
        {
          title: 'Learning Hub',
          description: 'A platform offering webinars, in-conversations, masterclasses, workshops, panel discussions, and more to foster growth and expand expertise.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.programs-section {
  background: #f7fbff; /* Light blue background to match the design */
  padding-block: 5rem;
}

.section__container {
  max-width: 1200px;
  margin: 0 auto;
}

.section__row {
  align-items: center;
}

.section__img {
  border-radius: 1rem;
  aspect-ratio: 4/3; /* Adjusted to match the image proportions */
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
}

@media only screen and (min-width: 960px) {
  .section__img {
    width: 90%;
  }
}

.section__title {
  font-family: 'DM Sans Bold', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  line-height: 120%;
  color: #111827;
  margin-bottom: 2rem;
  text-align: left;
}

/* Show mobile title only on small screens */
.section__title--mobile {
  display: block;
}

.section__title--desktop {
  display: none;
}

@media only screen and (min-width: 960px) {
  .section__title--mobile {
    display: none;
  }

  .section__title--desktop {
    display: block;
  }
}

.programs__wrapper {
  display: flex;
  flex-direction: column;
  text-align: left;
  height: 100%;
}

.program__item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.program__content {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}

.program__arrow {
  width: 24px;
  height: 24px;
  margin-top: 6px;
  color: #00aeff; /* Blue color for the arrow */
}

.program__title {
  font-family: 'Manrope Medium', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.program__description {
  font-family: 'Manrope Medium', sans-serif;
  font-size: 1rem;
  color: #4b5563;
  margin: 0.25rem 0 0 0;
  line-height: 1.5;
}

/* Responsive styles */
@media only screen and (max-width: 960px) {
  .section__title {
    font-size: 2rem;
  }

  .section__col {
    display: flex;
    justify-content: center;
  }

  .program__title {
    font-size: 1.125rem;
  }

  .program__description {
    font-size: 0.875rem;
  }

  .program__arrow {
    width: 20px;
    height: 20px;
  }

  .program__item {
    margin-bottom: 1.25rem;
  }
}

@media only screen and (max-width: 600px) {
  .section__img {
    margin-bottom: 2rem;
  }

  .section__title {
    font-size: 1.75rem;
  }

  .program__title {
    font-size: 1rem;
  }

  .program__description {
    font-size: 0.813rem;
  }
}
</style>